import {action, computed, observable, toJS} from 'mobx';

export default class {
  maxBioLength = 500;
  accentColors = ['369ff4', 'ffca0a', '59C77f', '8ed4cc'];
  socialShareLinkTypes = ['website', 'facebook', 'twitter', 'instagram'];
  textColors = ['333232', 'ffffff'];

  @observable accentColor = '';
  @observable bio = '';
  @observable customAccentColor = '';
  @observable isHiddenDonationAmount = false;
  @observable socialShareLinks = [];
  @observable deletedSocialShareLinks = [];
  @observable validatedCustomAccentColor = '';
  @observable textColor = '';
  @observable remoteModalTriggerClicked = false;
  @observable photoUploading = false;
  @observable formSubmitting = false;

  @action addSocialShareLink = () => {
    this.socialShareLinks.push({
      id: '',
      linkType: 'website',
      linkValue: '',
    });
  }

  @action deleteSocialShareLink = (index) => {
    const deletedLinkObservableArray = this.socialShareLinks.splice(index, 1);
    const deletedLink = toJS(deletedLinkObservableArray[0]);
    if (!deletedLink.id) return;
    this.deletedSocialShareLinks.push(deletedLink);
  }

  @action setSocialShareLinkType = (index, value) => {
    this.socialShareLinks[index].linkType = value;
  }

  @action setSocialShareLinkValue = (index, value) => {
    this.socialShareLinks[index].linkValue = value;
  }

  @computed get bioLength() {
    return this.bio.length;
  }

  @computed get socialShareLinksLength() {
    return this.socialShareLinks.length;
  }

  @computed get remainingBioCharacters() {
    return this.maxBioLength - this.bioLength;
  }

  @computed get bioExceedsMaxLength() {
    return this.bioLength > this.maxBioLength;
  }
}
